import {
  useCart,
  useCartLine,
  CartLineQuantityAdjustButton,
  CartLinePrice,
  CartLineQuantity,
  Image,
  Link,
} from '@shopify/hydrogen';
import type { Image as ImageType } from '@shopify/hydrogen/storefront-api-types';
import { Heading, Text } from '~/rs-components/elements';
import RemoveIcon from '~/assets/icons/RemoveIcon';
import { multiStore, quantityCustom } from '../../../setup/settings/__product';
import NoImage from "~/assets/no_image_big.jpg";
import { getCurrencyValue } from '~/lib/index';
import { ReactElement, JSXElementConstructor, ReactFragment, ReactPortal, useState, useEffect } from 'react';
import NoImageMultiStore from '~/assets/missingImage.jpg';
import axios from "axios";
import { retailSystem } from "../../../setup/settings";
import TrashIcon from "../../../setup/custom_icons/Trash";
import SetupCartLineDetail from "../../../setup/components/setup/SetupCartLineDetail.client";

export function CartLineItem({ currency }: { currency: string }) {
  const { linesRemove, linesUpdate, id: cartId, status } = useCart();
  const { id: lineId, quantity, merchandise, attributes, cost } = useCartLine();
  const [showItem, setShowItem] = useState<boolean>(false)
  const multiplierQuantity: number = quantityCustom.visible && attributes != undefined && attributes.length > 0 ? parseInt(attributes.find(a => a.key == "multiplierQuantity")?.value) : 1;
  const minimumQuantity: number = quantityCustom.visible && attributes != undefined && attributes.length > 0 ? parseInt(attributes.find(a => a.key == "minimumQuantity")?.value) : 1;
  const busy = status !== 'idle';

  const [optionsSelected, setOptionsSelected] = useState<any>([]);
  const merchandiseId = merchandise.id?.split('/')[merchandise.id?.split('/').length - 1];
  async function getOptions() {
    let tokenKey = cartId?.split('/') ? cartId?.split('/')[cartId?.split('/').length - 1] : "";
    const cartToken = tokenKey.split('?')[0];

    if (cartToken != "" && merchandise.title != "DefaultVariant") {
      try {
        const response = await axios.get(`${retailSystem.cartCache}/GetCartVariantOptions/${cartToken}`);
        setOptionsSelected(response.data);
      } catch (error) {
        console.error('Error en la solicitud GET:', error);
      }
    }
  }

  async function updateCart(variantId: string) {

    let tokenKey = cartId?.split('/') ? cartId?.split('/')[cartId?.split('/').length - 1] : "";
    const cartToken = tokenKey.split('?')[0];
    const isStockVariant = /^[0-9]+$/.test(merchandise.title) 

    if (cartToken != "" && merchandise.title != "DefaultVariant" && !isStockVariant) {
      try {
        const response = await axios.post(`${retailSystem.cartCache}/DeleteCartVariantOption/${cartToken}/${variantId}`);
        setOptionsSelected(response.data);
      } catch (error) {
        console.error('Error en la solicitud GET:', error);
      }
    }

  }
  useEffect(() => {
    getOptions()
  }, [])

  const substractQuantity = () => {
    const result = quantity - multiplierQuantity;
    if (result < minimumQuantity || result < multiplierQuantity) return minimumQuantity > multiplierQuantity ? minimumQuantity : multiplierQuantity;
    if (result % multiplierQuantity == 0 && result >= minimumQuantity && result >= multiplierQuantity) return result;
    else return quantity;
  }

  const sumQuantity = () => {
    const result = quantity + multiplierQuantity;
    if (result % multiplierQuantity == 0 && result >= minimumQuantity) return result;
    else return quantity;
  }


  const removeLine = (lineId: any) => {
    linesRemove([lineId])
    const variantId = merchandise.id?.split('/') ? merchandise.id?.split('/')[merchandise.id?.split('/').length - 1] : "";
    updateCart(variantId)
  }
  const CartLineUpdateQuantity = () => {
    return (
      <>
        <label htmlFor={`quantity-${lineId}`} className="sr-only">
          Quantity, {quantity}
        </label>
        <div className="flex items-center border rounded">
          <button
            type="button"
            onClick={() => linesUpdate([{ id: lineId, quantity: substractQuantity(), merchandiseId: merchandise.id, attributes: attributes }])}
            className="flex items-center justify-center w-10 h-10 border rounded"
          >
            &#8722;
          </button>
          <CartLineQuantity as="div" className="px-2 text-center" />
          <button
            type="button"
            onClick={() => linesUpdate([{ id: lineId, quantity: sumQuantity(), merchandiseId: merchandise.id, attributes: attributes }])}
            className="flex items-center justify-center w-10 h-10 border rounded"
          >
            &#43;
          </button>
        </div>
      </>
    )
  }

  return (
    <>
      <div className="wrapperItems">
        {(lineId && merchandise) ? (
          <>
            <li key={lineId} className="flex gap-4 no-border">
              <div className="flex-shrink">
                {merchandise.image ?
                  <Image
                    width={112}
                    height={112}
                    widths={[112]}
                    data={merchandise.image as ImageType}
                    loaderOptions={{
                      scale: 2,
                      crop: 'center',
                    }}
                    className="object-cover object-center w-24 h-24 border rounded md:w-28 md:h-28"
                  />
                  :
                  <img src={multiStore ? NoImageMultiStore : NoImage}></img>
                }

              </div>

              <div className="flex justify-between flex-grow">
                <div className="grid gap-2">
                  <Heading as="h3" size="copy">
                    <Link to={`/products/${merchandise.product.handle}`}>
                      {merchandise.product.title}
                    </Link>
                  </Heading>


                  <div className="flex items-center gap-2">
                    <div className="flex justify-start text-copy">
                      {quantityCustom.visible ? CartLineUpdateQuantity() : CartLineQuantityAdjust(lineId, quantity)}
                    </div>

                    <button
                      type="button"
                      onClick={() => removeLine(lineId)}
                      className={`flex items-center justify-center w-10 h-10 border rounded ${busy ? 'cursor-not-allowed opacity-50' : ''}`}
                    >
                      <TrashIcon />

                    </button>
                  </div>
                </div>
                <Text className='w-full mb-3'>
                  <span className='mb-3'>{getCurrencyValue(currency, cost.totalAmount.amount)}</span>
                </Text>
              </div>
            </li >

            {/* Renderizar SetupCartLineDetail si las opciones existen */}
            {optionsSelected && optionsSelected?.cartLineItems?.length > 0 &&
              optionsSelected?.cartLineItems?.find(c => c.lineItemId == merchandise.id?.split('/')[merchandise.id?.split('/').length - 1])?.options && (
                <SetupCartLineDetail
                  optionsSelected={optionsSelected}
                  merchandise={merchandise}
                  showItem={showItem}
                  setShowItem={setShowItem}
                />
              )
            }
          </>
        ) : (
          <div className="loader-customize"></div>
        )}
      </div >
    </>
  );
}

function CartLineQuantityAdjust({
  lineId,
  quantity,
}: {
  lineId: string;
  quantity: number;
}) {
  return (
    <>
      <label htmlFor={`quantity-${lineId}`} className="sr-only">
        Quantity, {quantity}
      </label>
      <div className="flex items-center border rounded">
        <CartLineQuantityAdjustButton
          adjust="decrease"
          aria-label="Decrease quantity"
          className="w-10 h-10 transition hover:text-primary disabled:cursor-wait"
        >
          &#8722;
        </CartLineQuantityAdjustButton>
        <CartLineQuantity as="div" className="px-2 text-center" />
        <CartLineQuantityAdjustButton
          adjust="increase"
          aria-label="Increase quantity"
          className="w-10 h-10 transition hover:text-primary disabled:cursor-wait"
        >
          &#43;
        </CartLineQuantityAdjustButton>
      </div>
    </>
  );
}

